<template>
  <div
    class="overflow-y-auto ml-16 p-7 pb-0 mb-0 rounded-lg border-2 border-blue-600"
  >
    <div id="title">
      <div class="btn btn-info w-full mb-5">Notifications</div>
    </div>
    <table class="table w-full">
      <!-- <thead>
        <tr>
          <th>Id</th>
          <th>Date</th>
          <th>Message</th>
        </tr>
      </thead> -->
      <tbody class="">
        <!-- <tr>
          <th>1</th>
          <td>20-02-2021</td>
          <td>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Nostrum,
            sequi.
          </td>
        </tr>
        <tr>
          <th>2</th>
          <td>23-05-2020</td>
          <td>Desktop Support Technician</td>
        </tr>
        <tr>
          <th>3</th>
          <td>12-02-2000</td>
          <td>Tax Accountant</td>
        </tr> -->
        <h1 class="text-center text-2xl font-bold font-serif mb-10">
          No New Notifications Yet
        </h1>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
